import React from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import './Translations.css';

export default function TranslationLayout(): React.ReactElement | null {
    const { languageCode } = useParams<{ languageCode: string }>();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    if (!languageCode) {
        return <div>Chybí kód jazyka v URL.</div>;
    }

    let sectionLabel = 'Číselníky';

    if (pathname.endsWith('/municipality')) {
        sectionLabel = 'Municipality';
    } else if (pathname.endsWith('/body')) {
        sectionLabel = 'Orgány';
    } else if (pathname.endsWith('/enums')) {
        sectionLabel = 'Číselníky';
    }

    return (
        <div className='translation-page'>
            <div className='translation-content'>
                <div className='translation-page__header'>
                    <div className='translation-page__back-wrap'>
                        <i
                            className='translation-page__back pi pi-arrow-left mr-3 text-700 hover:text-900 transition-colors transition-duration-200'
                            onClick={() => navigate('/admin/jazyk')}
                        />
                    </div>
                    <div className='translation-page__title-wrap'>
                        <h1 className='translation-page__title'>
                            Překlady jazyka {languageCode.toUpperCase()} - {sectionLabel}
                        </h1>
                    </div>
                </div>
            </div>

            <Outlet />
        </div>
    );
}
